import slugify from "slugify";

const isInArray = (v, arr) => arr.indexOf(v) > -1;

const convertEntoVi = (str) =>
  slugify(str, { locale: "vi", lower: true, replacement: " " });

export const filterByKey = (input, key, val) => {
  if (!input || !Array.isArray(input) || input.length === 0) {
    return [];
  }

  return input.filter((elm) =>
    elm && elm.hasOwnProperty(key)
      ? (Array.isArray(elm[key]) ? isInArray(val, elm[key]) : val === elm[key])
      : false
  );
}

export const filterByCode = (input, key, val) => {
  if (!input || !Array.isArray(input) || input.length === 0) {
    return [];
  }

  return input.filter((elm) =>
    elm && elm.hasOwnProperty(key)
      ? (Array.isArray(elm[key]) ? isInArray(val, elm[key]) : val === elm[key])
      : false
  );
}

export const filterBySearch = (input, key, val) => {
  if (!input || !Array.isArray(input) || input.length === 0) {
    return [];
  }

  return input.filter(
    (elm) => elm && elm[key] && convertEntoVi(elm[key]).indexOf(val.trim().toLowerCase()) >= 0
  );
}

export const categorizeArrByKey = (input, key) => {
  if (!input || !Array.isArray(input)) {
    return {};
  }

  return input.reduce((acc, elm) => {
    if (elm && elm.hasOwnProperty(key)) {
      if (Array.isArray(elm[key])) {
        elm[key].forEach((item) => {
          acc[item] = acc[item] || [];
          acc[item].push(elm);
        });
      } else {
        acc[elm[key]] = acc[elm[key]] || [];
        acc[elm[key]].push(elm);
      }
    }
    return acc;
  }, {});
}

//shallow copy only
export const filterObjByKey = (obj, key) => {
  if (!obj || typeof obj !== 'object') {
    return {};
  }

  const newObj = { ...obj };
  return {
    [key]: newObj[key]
  };
}

export const isEmptyObj = (obj) =>
  !obj || typeof obj !== 'object' || Object.keys(obj).length === 0;

export const limitStr = (str, max = 16) => {
  if (!str || typeof str !== 'string') {
    return "";
  }

  return str.slice(0, max) + (str.length > max ? "..." : "");
};
// Function to wrap text for SVG rendering
export const wrapTextForSVG = (text, maxLineLength = 11) => {
  if (!text || text.length <= maxLineLength) {
    return [text];
  }

  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  for (const word of words) {
    if ((currentLine + ' ' + word).trim().length <= maxLineLength) {
      currentLine = (currentLine + ' ' + word).trim();
    } else {
      if (currentLine) {
        lines.push(currentLine);
      }
      currentLine = word;
    }
  }

  if (currentLine) {
    lines.push(currentLine);
  }

  return lines;
};
